import React, { useState } from 'react';

import Switch from '@material-ui/core/Switch';

const SwitchInput = ({ accessor, onChange }) => {
  let [value, setValue] = useState(false);

  const onChng = (e) => {
    setValue(e.target.checked);
    onChange({ accessor, value: e.target.checked });
  };

  return (
    <Switch checked={value} onChange={onChng} name="checkedA" inputProps={{ 'aria-label': 'secondary checkbox' }} />
  );
};

export default SwitchInput;
